<template>
  <div class="program-exit" redesign>
    <!-- Header -->
    <NomineeProgressBar
      stepName="Program Exit"
      :programMonth="user.currentProgramMonth"
    />

    <div class="form-container program-exit-form">
      <LoadSpinner v-if="loading" :color="`#${organizationDetails.darkBrandColor}`" />
      <template v-if="!loading">
        <SurveyResponseComponent
          :surveyResponse="surveyResponse"
          :cleanSurvey="false"
          buttonText="Submit"
          @survey-done="handleSubmit"
          :useSubmitButton="true"
          :darkText="true"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import { LoadSpinner } from '@/components'
import NomineeProgressBar from '@/components/stepper/NomineeProgressBar'
import SurveyResponseComponent from '@/components/SurveyResponse'

import NomineesApi from '@/services/nominees'
import SurveyResponseModel from '@/services/surveyresponses'

export default {
  name: 'StipendProgramExit',
  components: {
    LoadSpinner,
    NomineeProgressBar,
    SurveyResponseComponent,
  },
  data() {
    return {
      loading: true,
      surveyResponse: null,
    }
  },
  async mounted() {
    await new Promise(r => setTimeout(() => r(), 500))

    let programExitSurveyResponse = this.currentRequest.program_exit_ref.id
    this.getSurveyResponse(programExitSurveyResponse)
    this.loading = false
  },
  methods: {
    getSurveyResponse(id) {
      const surveyResponsePromise = SurveyResponseModel.api
        .retrieve(id)
        .then(surveyResponse => {
          this.surveyResponse = surveyResponse
        })
        .catch(error => {
          try {
            error.response.status === 404 ? (this.errorCode = 404) : (this.errorCode = 500)
          } catch {
            this.errorCode = 500
          }
        })
      return surveyResponsePromise
    },
    handleSubmit() {
    },
  },
  computed: {
    ...mapState(['user', 'organizationDetails', 'organizationCssVars', 'currentRequest']),
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/mixins/responsive';

.program-exit {
  display: flex;
  flex-direction: column;

  .program-exit-form {
    @extend .constrain-tablet-and-up;

    @media (min-width: 1140px) {
      max-width: 1076px !important;
    }
  }
}
</style>
